module.exports = __webpack_public_path__ + "static/media/LLCHARLO.465e6d56.TTF";